// apps/website/src/components/SessionInitializer.tsx

import { useEffect } from 'react';
import { sessionService } from '@dopomogai/agent-kit';

export function SessionInitializer() {
  useEffect(() => {
    sessionService.initialize();
  }, []);
  return null;
}

export default SessionInitializer;
